module.exports = __webpack_public_path__ + "static/media/brand-icons.a1a749e8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/brand-icons.svg
// module id = 416
// module chunks = 0